export const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
export const domain = process.env.REACT_APP_COGNITO_DOMAIN;
export const userPoolId = process.env.REACT_APP_COGNITO_POOL_ID;
